/**
 * builtTabsNav — THE-TAB-IS-IN-THE-MENU-1. Built tabs, joined to the menu.
 *
 * AT THE SAME HOP AS RECORD TYPES AND BUILT PAGES, and before the account
 * layer, for the reason `useNavSections` already records: a built thing is not
 * an override, it is a different source, so it joins the tree and is then
 * subject to every subtractive layer exactly as our own sections are. A
 * merchant can hide a built tab from Settings; nobody can use a hide row to
 * put one back.
 *
 * ABOVE THE DIVIDER, AND AT THE TOP OF IT. Each tab is its own row, first in
 * the menu, in the order `tabsFromMap` returns — oldest first, so the newest is
 * last. Settings, Refer a friend, Ghost and Agents are drawn by the divider and
 * are not in this list.
 *
 * UNDO-REMOVES-ONLY-ITS-OWN-1 — THEY USED TO GO BELOW EVERYTHING ELSE, just
 * ahead of Settings, and the capture of 16 September measured the first one at
 * 501 pixels down a 900 pixel laptop, under the Ghost row, where a hit test did
 * not land on it. PRE-LAUNCH item 68. What a merchant asked Ghost to build is
 * the first thing in their menu, not the last.
 */
import type { NavSection } from './navConfig'
import type { BuiltTab } from './builtTabs'

/** What a built tab row says under its name, and in search. */
export const BUILT_TAB_DESCRIPTION = 'A tab Ghost built for this business.'

export function withBuiltTabs(
  sections: ReadonlyArray<NavSection>,
  tabs: ReadonlyArray<BuiltTab>,
  icon: NavSection['icon'],
): NavSection[] {
  const rows: NavSection[] = tabs.map((t) => ({
    id: t.id,
    label: t.label,
    description: BUILT_TAB_DESCRIPTION,
    to: t.to,
    icon,
    children: [],
    keywords: ['built', 'tab', t.label.toLowerCase()],
  }))
  return [...rows, ...sections]
}
